import OapImmersiveCopyOnVideo from './code/Scripts/components/OapImmersiveCopyOnVideo.vue';

export default {
  components: {
    OapImmersiveCopyOnVideo,
  },
};
